<template>
  <div class="report-filter" :key="updateKey">
    <!-- Toggler -->
    <div class="toggler">
      <div class="left">
        <input :checked="isFilterEnabled"
               @change="toggleFilter(filterKey)"
               type="checkbox">
      </div>
      <div class="right">
        <a href="#" @click.prevent="toggleFilter(filterKey)"><b>Date Ticket Resolved</b></a>
      </div>
    </div>
    <!-- / Toggler -->

    <!-- Options -->
    <div class="options" v-if="isFilterEnabled">
      <el-date-picker
          size="small"
          value-format="yyyy-MM-dd"
          style="width: 100%; margin-bottom: 10px;"
          v-model="date_start"
          placeholder="Start date">
      </el-date-picker>
      <el-date-picker
          size="small"
          value-format="yyyy-MM-dd"
          style="width: 100%;"
          v-model="date_end"
          placeholder="End date">
      </el-date-picker>
    </div>
    <!-- / Options -->
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Tickets from "../../../../../mixins/Tickets";

export default {
  name: "DateTicketResolvedFilter",
  mixins: [Tickets],
  data() {
    return {
      filterKey: 'date_ticket_resolved',
      updateKey: 1,
      startDate: null,
      endDate: null
    }
  },
  methods: {
    ...mapActions('reportEditor', {
      toggleFilter: 'toggleFilter',
      setDateTicketResolvedFilter: 'setDateTicketResolvedFilter'
    }),

    incrementUpdateKey() {
      this.updateKey += 1;
    },

    updateDateRange(val) {
      this.setDateTicketResolvedFilter(val);
      this.incrementUpdateKey();
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      agents: 'agents',
      filtersEnabled: 'filtersEnabled',
      params: 'params'
    }),

    date_start: {
      get() {
        return this.params['date_ticket_resolved']['start_date'];
      },

      set(val) {
        this.setDateTicketResolvedFilter({
          ...this.params['date_ticket_resolved'],
          start_date: val
        });
        this.$nextTick(() => {
          this.incrementUpdateKey();
        });
      }
    },

    date_end: {
      get() {
        return this.params['date_ticket_resolved']['end_date'];
      },

      set(val) {
        this.setDateTicketResolvedFilter({
          ...this.params['date_ticket_resolved'],
          end_date: val
        });
        this.$nextTick(() => {
          this.incrementUpdateKey();
        });
      }
    },

    isFilterEnabled() {
      return this.filtersEnabled.includes(this.filterKey);
    }
  }
}
</script>

<style lang="scss" scoped>
.report-filter {
  background: #fff;
  border-radius: 5px;
  padding: 13px 15px;
  margin-bottom: 15px;

  .toggler {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left {
      flex-shrink: 1;
      padding-top: 4px;
      padding-right: 15px;
    }

    .right {
      flex: 1;
      font-weight: 600;
      color: #2c5cc5;
    }
  }

  .options {
    margin-top: 10px;
  }
}
</style>